import React, { useState } from 'react'
import { Box, FilterChip } from 'pcln-design-system'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { SponsoredFilter } from '../../SponsoredFilter'
import { mwebFilterAdId } from '../../../constants/constants'
import { useAirlinesFilters } from '../AirlinesFilters/hooks/useAirlinesFilters'
import { useDebouncedListingsFilterCall } from '../useDebouncedListingsFilterCall/useDebouncedListingsFilterCall'

const ChipWrapper = styled(Box)`
  ${({ $visible }) =>
    !$visible &&
    `
    position: fixed;
    left: -9999px;
    top: 0;
    width: 150px;
    min-height: 32px;
    z-index: -1;
  `}
`

const StyledChip = styled(FilterChip)`
  margin: 0 2px 0 2px;
  width: fit-content;
  max-height: 60px;
  overflow: hidden;

  & [data-testid='chipContentWrapper'] {
    width: fit-content;
    min-height: 32px;
    min-width: 120px;
  }
`

function MobileSponsoredFilterChip({ pclnBootstrapData }) {
  const [adVisible, setAdVisible] = useState(false)
  const [sponsoredCarrierCode, setSponsoredCarrierCode] = useState(null)

  const includedCarriers = useSelector((state) => {
    const activeTabId = state.activeTabId || 1
    return state.filterInfo?.values?.[`includedCarriers${activeTabId}`] || []
  })
  const isSelected =
    includedCarriers?.length === 1 &&
    !!sponsoredCarrierCode &&
    includedCarriers?.includes(sponsoredCarrierCode)

  const { debouncedListingsFilterCall } = useDebouncedListingsFilterCall()
  const { resetClick } = useAirlinesFilters({
    changeHandler: () => debouncedListingsFilterCall(pclnBootstrapData, 'filter'),
    isDynamic: true,
  })

  const handleChipClick = () => {
    if (isSelected) {
      setSponsoredCarrierCode(null)
      resetClick()
    }
  }

  return (
    <ChipWrapper $visible={adVisible}>
      <StyledChip
        id='sponsored-filter-ad'
        selected={isSelected}
        px={2}
        mx={6}
        data-test-id='SPONSORED_FILTER_CHIP'
        aria-label='sponsored filter chip'
        onClick={handleChipClick}
        showActionIcon={isSelected}
      >
        <SponsoredFilter
          pclnBootstrapData={pclnBootstrapData}
          adId={mwebFilterAdId}
          className='ad'
          minScreenSize='' //empty string triggers display: block default
          eventName='APPLY_AIR_MWEB_CARRIER_FILTER'
          maxWidth={150}
          minWidth={120}
          isMobile
          onAdVisible={() => setAdVisible(true)}
          onCarrierSelected={setSponsoredCarrierCode}
        />
      </StyledChip>
    </ChipWrapper>
  )
}

export { MobileSponsoredFilterChip }
